import React from 'react';
import { connect } from 'react-redux';
import './LoginScreen.scss';

import { withRouter } from 'react-router-dom' 

import { Fire } from '../../services'
import { saveName } from '../../actions/auth.action'

interface Props {
  logging: boolean;
  history: any;

  saveName: (name: any) => void;
}
const LoginScreen: React.FC<Props> = (props) => {
  
  const [forgotten, setForgotten] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [checked, setChecked] = React.useState(false)

  const [user, setUser] = React.useState<any>({})
  const [errors, setErrors] = React.useState<any>({})

  const onChange = (key: string, value: string) => {
    user[key] = value
    setUser({...user})
  }

  const login = async () => {
    if (loading)
      return;
    const email = user.email
    const password = user.password

    setLoading(true)
    try {
      await Fire.auth().signInWithEmailAndPassword(email, password)
    } catch (err) {
      const errors: any = {}
      errors.login = 'Identifiants incorrects, veuillez réessayer'
      setErrors(errors)
    }
    setLoading(false)
  }

  const forgotPassword = async () => {
    if (loading)
      return;
    setLoading(true)
    try {
      await Fire.auth().sendPasswordResetEmail(user.email)
    } catch (err) {}
    setLoading(false)

    alert("Suivez les étapes envoyées par mail à l'adresse: " + user.email)
  }

  return (
    <div className="login">
      <div className="login-box">

        <div className="card">
          <div className="login-logo">
            <img alt="Login" src={require('../../images/logo.png')} style={{width: 120, objectFit: 'contain'}} />
            <div>Connectez-vous</div>
          </div>

          <div className="card-body login-card-body">
            { errors.login !== undefined &&
              <p className="login-box-msg text-danger">{errors.login}</p>
            }

            <div>
              <div className="input-group mb-3">
                <input
                  value={user.email}
                  type="email"
                  className={["form-control", errors.email ? "form-error" : ""].join(' ')}
                  placeholder="Entrez votre email"
                  onChange={(evt) => onChange('email', evt.target.value)}
                  />
                <div className="input-group-append">
                  <div className={["input-group-text", errors.email ? "form-error" : ""].join(' ')}>
                    <span className="fas fa-envelope"></span>
                  </div>
                </div>
              </div>
              { !forgotten &&
                <div className="input-group mb-3">
                  <input
                    value={user.password}
                    type="password"
                    className={["form-control", errors.password ? "form-error" : ""].join(' ')}
                    placeholder="Mot de passe"
                    onChange={(evt) => onChange('password', evt.target.value)}
                    />
                  <div className="input-group-append">
                    <div className={["input-group-text", errors.password ? "form-error" : ""].join(' ')}>
                      <span className="fas fa-lock"></span>
                    </div>
                  </div>
                </div>
              }
              <div className="row">
                <div className="col-4">
                  <button
                    disabled={loading}
                    className="btn btn-primary"
                    style={{paddingLeft: 20, paddingRight: 20, marginBottom: 20}}
                    onClick={() => forgotten ? forgotPassword() : login()}>
                    {forgotten ? loading ? 'Envoi...' : 'Envoyer' : loading ? 'Connexion...' : 'Connexion'}
                  </button>
                </div>
              </div>
            </div>

            { forgotten ? (
              <p className="mb-1">
                <span className="text-primary" style={{cursor: 'pointer'}} onClick={() => setForgotten(false)}>{'>'} Retour</span>
              </p>
            ) : (
              <React.Fragment>
                <p className="mb-1">
                  <span className="text-primary" style={{cursor: 'pointer'}} onClick={() => setForgotten(true)}>{'>'} Mot de passe oublié ?</span>
                </p>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  logging: state.authReducer.logging,
})
const mapDispatchToProps = (dispatch: any) => ({
  saveName: (name: any) => dispatch(saveName(name)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginScreen))
